import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

import AddAppointmentLayer from "../components/AddAppointmentLayer";
import AddStaffLayer from "../components/AddStaffLayer";


const AddStaffPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Add Staff" />

        {/* AddUserLayer */}
        <AddStaffLayer />


      </MasterLayout>
    </>
  );
};

export default AddStaffPage;
